module.exports = "/_next/static/images/cc70d77e92b99d7f54d5bb3ff54e11b5-roxinho-card-with-phone-md@2x.jpg.webp";